module.exports = __webpack_public_path__ + "img/gear.a533760b.svg";